export function getPointListBottomBorderStyle(color: string): string {
  return `border-bottom-right-radius: 0; border-bottom-left-radius: 0;border-bottom: solid;border-color: ${color};`;
}
